import classNames from 'classnames';
import React from 'react';
import CodeSparkThemedTypography from '../../../../components/elements/CodeSparkThemedTypography';
import CtaButton from '../../../../components/elements/CtaButton';
import CtaButtonContainer from '../../../../components/elements/CtaButton/CtaButtonContainer';
import ImageTextCard, {
  CardBody,
  CardContent,
  CardImage,
  CardTitle,
} from '../../../../components/elements/ImageTextCard';
import {
  ColumnCenter,
  SectionPaddingVertical,
  SectionWidth,
} from '../../../../components/global/Layout';
import { useExperimentVariantData } from '../../../../experiments/hooks';
import { getCodingStepsVariantData } from './codeStepsData';

import styles from './CodingSteps.module.css';

const CTA_ID = 'section_coding_steps';

const experimentVariants = ['homepageRedesign', 'premiumOndemandClasses'];
function CodingSteps({ ctaLabel, onCtaClick }) {
  const { header, steps } = useExperimentVariantData(experimentVariants, getCodingStepsVariantData);
  const handleCtaClick = e => onCtaClick(e, CTA_ID);

  return (
    <SectionPaddingVertical className={styles.codingStepsSection}>
      <SectionWidth>
        <ColumnCenter>
          <CodeSparkThemedTypography
            variant="h2"
            align="center"
            className={styles.codingStepsTitle}
          >
            {header}
          </CodeSparkThemedTypography>

          <div className={classNames('grid-x grid-margin-x', styles.codingStepsContent)}>
            {steps.map(({ img, title, body }, i) => {
              const stepNumber = i + 1;
              return (
                <ImageTextCard key={`coding_step_${i}`}>
                  <CardImage src={img} alt={title} />

                  <CardContent>
                    <CardTitle align="center" className={styles.codingStepsCardTitle}>
                      Step {stepNumber}:
                      <span>{title}</span>
                    </CardTitle>

                    <CardBody>{body}</CardBody>
                  </CardContent>
                </ImageTextCard>
              );
            })}
          </div>

          <CtaButtonContainer className={styles.codingStepsCtaContainer} fullWidthMobile>
            <CtaButton onClick={handleCtaClick} type="primary2" fullWidthMobile>
              {ctaLabel}
            </CtaButton>
          </CtaButtonContainer>
        </ColumnCenter>
      </SectionWidth>
    </SectionPaddingVertical>
  );
}

export default CodingSteps;



// WEBPACK FOOTER //
// ./src/containers/Home/sections/CodingSteps/index.js